(function(){
var EB_GIFT_KEY='✓ Included free';
var EB_GIFT_VAL='Free eBooks + 100+ hours of audiobooks — emailed instantly after checkout';
function tilePrice(el){
  var disp=el.querySelector('.eb-tier-h-price');
  var shown=disp?(disp.textContent||'').trim():'';
  if(!shown)shown=(el.getAttribute('data-price')||'').trim();
  return shown;
}
function resyncPrice(){
  var sel=document.querySelector('.eb-tier.eb-sel');if(!sel)return;
  var shown=tilePrice(sel);if(!shown)return;
  document.querySelectorAll('.eb-atc-price').forEach(function(s){if((s.textContent||'').trim()!==shown)s.textContent=shown;});
}
window.ebResyncPrice=resyncPrice;
function selTier(el){
  document.querySelectorAll('.eb-tier').forEach(function(t){t.classList.remove('eb-sel');});
  el.classList.add('eb-sel');
  var q=el.getAttribute('data-qty'),p=el.getAttribute('data-price'),n=el.getAttribute('data-note');
  if(q)document.querySelectorAll('.eb-atc-qty').forEach(function(s){s.textContent=q;});
  /* Mirror the tile's DISPLAYED price (currency-converted by Shopify Markets) into the CTA/
     sticky price spans. The converter briefly reverts the tile to base currency when these
     classes toggle, so re-mirror on a few short delays after it settles (proven fix). */
  var shown=tilePrice(el);
  if(shown)document.querySelectorAll('.eb-atc-price').forEach(function(s){s.textContent=shown;});
  var sn=document.getElementById('eb-stk-note');if(sn&&n)sn.textContent=n;
  /* BNPL per-payment: prefer the tile's Liquid-precomputed data-bnpl (correct currency + decimals,
     e.g. "€19,99"); only fall back to JS math for funnels that don't supply it. The old parseFloat
     path broke on EU money strings ("€79,95" -> "7995" -> /4 = €1998), so data-bnpl is authoritative. */
  var bnpl=el.getAttribute('data-bnpl');
  if(bnpl){document.querySelectorAll('.eb-bnpl-amt').forEach(function(s){s.textContent=bnpl;});}
  else{var pr=parseFloat((p||'').replace(/[^0-9.]/g,''));if(pr)document.querySelectorAll('.eb-bnpl-amt').forEach(function(s){s.textContent='$'+(pr/4).toFixed(2);});}
  [80,300,800,1800].forEach(function(ms){setTimeout(resyncPrice,ms);});
}
window.ebSelTier=selTier;
function swapHero(el){
  var m=document.getElementById('eb-hero-main'),u=el.getAttribute('data-full');
  if(m&&u&&m.getAttribute('src')!==u){m.style.opacity='0';var n=new Image();n.onload=n.onerror=function(){m.src=u;m.style.opacity='1';};n.src=u;}
  document.querySelectorAll('.eb-gthumb').forEach(function(t){t.classList.remove('eb-active');});
  el.classList.add('eb-active');
}
window.ebSwapHero=swapHero;
function init(){
  /* Purchase CTAs are owned by the funnel footer's single capture-phase drawer controller.
     Do not attach a second target listener here: the old listener rebuilt the cart and navigated
     straight to /checkout whenever the drawer controller was unavailable or errored. */
  var s=document.querySelector('.eb-tier.eb-sel')||document.querySelector('.eb-tier:not(.eb-tier-sold)');
  if(s)selTier(s);
  /* Do not eagerly fetch every 1200px gallery image. The selected image is fetched by
     swapHero() on demand; preloading all twelve cost roughly 1.5 MiB on every mobile visit. */
  try{
    var wrap=document.querySelector('.eb-tiers-row')||document.querySelector('.eb-tiers');
    if(wrap&&window.MutationObserver){
      var mo=new MutationObserver(function(){resyncPrice();});
      mo.observe(wrap,{subtree:true,childList:true,characterData:true});
    }
  }catch(e){}
  [400,1200,2500,5000].forEach(function(ms){setTimeout(resyncPrice,ms);});
}
if(document.readyState!=='loading')init();else document.addEventListener('DOMContentLoaded',init);
/* Geo: non-US visitors see worldwide shipping / printed-to-order; US (default) keeps Free US shipping + Printed in the USA. */
try{ if(window.EBGeo&&window.EBGeo.get){ window.EBGeo.get(function(g){ if(g&&g.isUS===false&&window.EBGeo.swapIntl){ window.EBGeo.swapIntl(); setTimeout(window.EBGeo.swapIntl,900); } }); } }catch(e){}


})();
